import styled from '@emotion/styled';

import RadioGroup from 'design-system/RadioGroup';
import { authColors, authLayout } from 'design-system/tokens';

export const ChannelChoice = styled(RadioGroup)`
  width: 100%;

  label {
    align-items: center;
    gap: 12px;
    padding: 8px 0;
  }

  label > span:first-of-type span {
    width: 24px;
    height: 24px;
    border-width: 2px;
    border-color: ${authColors.brand};

    &::after {
      background: ${authColors.brand};
    }
  }

  label > span:last-of-type {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${authColors.textBody};
  }
`;
export const ChannelList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: ${authLayout.fieldWidth};

  @media (max-width: ${authLayout.mobileBreakpoint}) {
    width: 100%;
  }
`;
export const EmptyChannels = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${authColors.textBody};
`;
